/* ============================================================================
   MURAL DEL PEDIDO — Portal Kennedy
   ---------------------------------------------------------------------------
   El pedido presentado con las fotos de los articulos en vez de como una tabla
   de codigos. El vendedor lo abre en el iPad delante del cliente y se lo manda
   por WhatsApp al salir.

   Lo que lo separa de un catalogo cualquiera es la etiqueta sobre cada foto:
   no dice solo QUE lleva el pedido, dice si PUEDE SALIR. Verde si hay stock,
   ambar con la fecha del contenedor si viene en camino, rojo si falta y no hay
   fecha. Esa informacion ya se cruza en Consulta de inventario; aqui se pone
   donde de verdad decide una venta.

   No vuelve a consultar nada que verPedido ya haya cargado:
     window._PED_LINEAS  las lineas
     window._pedEdInv    {itemcode: {bc, st, pn, fu}} con foto y stock
     window._pedEdHead   la cabecera
   Solo pide aparte las fechas de llegada, que no estan en esos globales.

   Prefijo `mur`.
============================================================================ */

var MUR_DOC=null, MUR_LINEAS=[], MUR_HEAD={}, MUR_INV={}, MUR_LLEG={};

// ── Utilidades ──────────────────────────────────────────────────────────────
function murEsc(s){
  return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function murNum(v){ var n=Number(v); return isFinite(n)?n:0; }
function murN(v){ return murNum(v).toLocaleString('en-US'); }
function murMon(v){
  return '$'+murNum(v).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
}
function murFecha(f){
  var p=String(f||'').slice(0,10).split('-');
  return p.length===3 ? (p[2]+'/'+p[1]+'/'+p[0].slice(2)) : '';
}
// Dias que faltan. La fecha se parte a mano: Safari lee "2026-09-10" como UTC
// y en Panama eso corre un dia.
function murDias(f){
  var p=String(f||'').slice(0,10).split('-');
  if(p.length!==3) return null;
  var d=new Date(+p[0], +p[1]-1, +p[2]);
  if(isNaN(d.getTime())) return null;
  var h=new Date(); h.setHours(0,0,0,0);
  return Math.round((d.getTime()-h.getTime())/86400000);
}

// Color estable a partir del SKU, para los articulos sin foto. Siempre el
// mismo color para el mismo articulo: parece intencional y no un error.
var MUR_COLORES=[
  ['#EEEDFE','#3C3489'], ['#E1F5EE','#085041'], ['#FAECE7','#712B13'],
  ['#FBEAF0','#72243E'], ['#E6F1FB','#0C447C'], ['#EAF3DE','#27500A'],
  ['#FAEEDA','#633806'], ['#F1EFE8','#444441']
];
function murColor(sku){
  var s=String(sku||''), h=0;
  for(var i=0;i<s.length;i++) h=(h*31+s.charCodeAt(i))|0;
  return MUR_COLORES[Math.abs(h)%MUR_COLORES.length];
}

// ── Disponibilidad ──────────────────────────────────────────────────────────
// Lo que decide el color de la etiqueta. Se compara contra lo que falta por
// entregar, no contra la cantidad pedida: si ya se despacho, da igual el stock.
function murEstado(l){
  var sku=l.itemcode;
  var inv=MUR_INV[sku]||{};
  var lleg=MUR_LLEG[sku]||{};
  var falta=murNum(l.openqty!=null ? l.openqty : l.quantity);
  var stock=murNum(inv.st);

  if(falta<=0)  return {k:'listo', t:'Despachado',        bg:'#E1F5EE', fg:'#085041'};
  if(stock>=falta) return {k:'ok',  t:'En stock',         bg:'#EAF3DE', fg:'#27500A'};

  var f=String(lleg.prox_llegada||'').slice(0,10);
  if(f){
    var d=murDias(f);
    return {k:'camino',
            t:'Llega '+murFecha(f)+(d!=null&&d>=0?(' \u00b7 '+d+'d'):''),
            bg:'#FAEEDA', fg:'#633806'};
  }
  if(murNum(lleg.onorder)>0)
    return {k:'camino', t:'En camino \u00b7 sin fecha', bg:'#FAEEDA', fg:'#633806'};

  return {k:'falta', t:'Sin existencia', bg:'#FCEBEB', fg:'#791F1F'};
}

// Bultos, que es como compra el mayorista. Sin dato, piezas.
function murPack(l){
  var inv=MUR_INV[l.itemcode]||{};
  return murNum(inv.pack)||murNum(l.packing)||0;
}
function murBultos(l){
  var pack=murPack(l), q=murNum(l.quantity);
  if(pack>1){
    var b=Math.floor(q/pack), r=q%pack;
    return murN(b)+' bulto'+(b===1?'':'s')+(r?(' + '+murN(r)+' pz'):'');
  }
  return murN(q)+' pz';
}

// El precio que se le dio de verdad al cliente. Se saca del total de la linea
// entre la cantidad, no del campo `price`: en SAP ese a veces ya trae el
// descuento aplicado y a veces no, y aqui el cliente esta mirando.
function murUnit(l){
  var q=murNum(l.quantity), t=murNum(l.linetotal);
  if(q>0 && t) return t/q;
  var p=murNum(l.price), d=murNum(l.descuentolinea);
  return (d>0 && d<100) ? p*(1-d/100) : p;
}

// "288 pz  ·  $10.83 c/u". Las piezas se omiten cuando el articulo va suelto,
// porque entonces la linea de bultos ya dice exactamente lo mismo.
function murDetalle(l){
  var partes=[];
  if(murPack(l)>1) partes.push(murN(l.quantity)+' pz');
  var u=murUnit(l);
  if(u>0) partes.push(murMon(u)+' c/u');
  return partes.join('  \u00b7  ');
}


/* ══════════════════════════════════════════════════════════════════════════
   ABRIR
   ══════════════════════════════════════════════════════════════════════════ */

async function murAbrir(docnum){
  MUR_DOC=docnum;

  // Se reutiliza lo que verPedido ya trajo. Volver a pedirlo seria una espera
  // de dos segundos delante del cliente por datos que ya estan en memoria.
  MUR_LINEAS = (window._PED_LINEAS||[]).slice();
  MUR_INV    = window._pedEdInv || {};
  MUR_HEAD   = window._pedEdHead || {};

  if(!MUR_LINEAS.length){
    try{
      var r=await Promise.all([
        q('pedidos','select=linenum,itemcode,dscription,quantity,price,linetotal,openqty,delivrdqty'
          +'&docnum=eq.'+docnum+'&order=linenum'),
        q('pedidos','select=docnum,docdate,cardcode,cardname,doctotal,nombrevendedor'
          +'&docnum=eq.'+docnum+'&limit=1')
      ]);
      MUR_LINEAS=r[0]||[]; MUR_HEAD=(r[1]&&r[1][0])||{};
    }catch(e){}
  }
  if(!MUR_LINEAS.length){ alert('No pude cargar las l\u00edneas del pedido.'); return; }

  murPintar(true);          // se abre de inmediato, con lo que ya hay
  await murCargarExtras();  // y las fechas de llegada entran despues
  murPintar(false);
}

// Las fechas de llegada y las unidades por bulto no estan en los globales de
// verPedido, asi que se piden aparte. Va DESPUES de pintar a proposito: el
// mural aparece al instante y las etiquetas se completan solas.
async function murCargarExtras(){
  var codes=MUR_LINEAS.map(function(l){ return l.itemcode; }).filter(Boolean);
  if(!codes.length) return;
  try{
    var en=Array.from(new Set(codes))
      .map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
    var r=await q('inventario',
      'select=itemcode,onorder,prox_llegada,unidadesbulto,onhand,disponiblebodega'
      +'&itemcode=in.('+en+')&limit=900');
    (r||[]).forEach(function(x){
      MUR_LLEG[x.itemcode]=x;
      var m=MUR_INV[x.itemcode]||{};
      if(m.pack==null) m.pack=murNum(x.unidadesbulto);
      if(m.st==null)   m.st=murNum(x.onhand!=null?x.onhand:x.disponiblebodega);
      MUR_INV[x.itemcode]=m;
    });
  }catch(e){}
}


/* ══════════════════════════════════════════════════════════════════════════
   PINTAR
   ══════════════════════════════════════════════════════════════════════════ */

function murPintar(crear){
  var ov=document.getElementById('mur-overlay');
  if(!ov){
    if(!crear) return;
    ov=document.createElement('div');
    ov.id='mur-overlay';
    ov.style.cssText='position:fixed;inset:0;background:var(--bg,#f5f5f7);z-index:14000;'
      +'overflow-y:auto;-webkit-overflow-scrolling:touch';
    document.body.appendChild(ov);
    document.body.style.overflow='hidden';
  }

  var tot=0, pzas=0;
  MUR_LINEAS.forEach(function(l){
    tot+=murNum(l.linetotal!=null?l.linetotal:(murNum(l.quantity)*murNum(l.price)));
    pzas+=murNum(l.quantity);
  });

  var h='';

  // ── Cabecera ──
  h+='<div style="position:sticky;top:0;z-index:2;background:var(--surface,#fff);'
    +'border-bottom:1px solid var(--border,#e5e7eb);padding:14px 18px;display:flex;'
    +'gap:12px;align-items:flex-start;flex-wrap:wrap">';
  h+='<div style="flex:1;min-width:200px">'
    +'<div style="font-size:16px;font-weight:700">Pedido '+murEsc(MUR_HEAD.docnum||MUR_DOC)+'</div>'
    +'<div style="font-size:12.5px;color:var(--text2);margin-top:2px">'
      +murEsc(MUR_HEAD.cardname||'')
      +(MUR_HEAD.nombrevendedor?(' \u00b7 '+murEsc(MUR_HEAD.nombrevendedor)):'')
      +(MUR_HEAD.docdate?(' \u00b7 '+murFecha(MUR_HEAD.docdate)):'')
    +'</div></div>';
  h+='<div style="text-align:right">'
    +'<div style="font-size:20px;font-weight:800">'+murMon(tot)+'</div>'
    +'<div style="font-size:11.5px;color:var(--text3)">'+MUR_LINEAS.length
      +' referencias \u00b7 '+murN(pzas)+' pz</div></div>';
  h+='<div style="display:flex;gap:7px;flex-wrap:wrap;width:100%">'
    +'<button class="btn btn-sm btn-p" onclick="murEnviar()" id="mur-btn-env">'
      +'\u2709 Enviar al cliente</button>'
    +'<button class="btn btn-sm" onclick="murPdf()" id="mur-btn-pdf">\u2b07 PDF</button>'
    +'<button class="btn btn-sm" onclick="murCerrar()" style="margin-left:auto">'
      +'\u2715 Cerrar</button>'
    +'</div>';
  h+='</div>';

  // ── Mural ──
  h+='<div style="padding:16px;display:grid;'
    +'grid-template-columns:repeat(auto-fill,minmax(190px,1fr));gap:12px">';

  MUR_LINEAS.forEach(function(l){
    var sku=String(l.itemcode||'');
    var inv=MUR_INV[sku]||{};
    var est=murEstado(l);
    var sub=murNum(l.linetotal!=null?l.linetotal:(murNum(l.quantity)*murNum(l.price)));

    h+='<div style="border:1px solid var(--border,#e5e7eb);border-radius:12px;'
      +'overflow:hidden;background:var(--surface,#fff)">';

    // La foto, o un recuadro de color con el nombre. Un hueco vacio se ve peor
    // que la tabla que estamos reemplazando.
    var par=null, conFoto=false;
    try{ if(typeof fotoPair==='function') par=fotoPair(inv.pn, inv.fu); }catch(e){}
    conFoto = !!(par && par.primary);
    if(conFoto){
      h+='<img src="'+murEsc(par.primary)+'" data-fb="'+murEsc(par.fb||'')+'" '
        +'loading="lazy" onerror="if(typeof fotoFallback===\'function\')fotoFallback(this)" '
        +'onclick="if(typeof imgZoom===\'function\')imgZoom(this.src)" '
        +'style="width:100%;height:150px;object-fit:cover;display:block;cursor:zoom-in;'
        +'background:var(--surface2,#f3f4f6)">';
    } else {
      var c=murColor(sku);
      h+='<div style="height:150px;background:'+c[0]+';color:'+c[1]+';display:flex;'
        +'align-items:center;justify-content:center;text-align:center;padding:12px;'
        +'font-size:13px;font-weight:700;line-height:1.3">'
        +murEsc((l.dscription||sku).slice(0,48))+'</div>';
    }

    h+='<div style="padding:9px 11px">';
    // Sin foto el nombre ya va dentro del recuadro de color: repetirlo aqui
    // deja la tarjeta diciendo lo mismo dos veces.
    if(conFoto){
      h+='<div style="font-size:13px;font-weight:600;line-height:1.25">'
        +murEsc(l.dscription||sku)+'</div>';
    }
    h+='<div style="font-size:10.5px;color:var(--text3);font-family:monospace'
      +(conFoto?';margin-top:2px':'')+'">'+murEsc(sku)+'</div>';
    h+='<div style="display:inline-block;margin-top:6px;font-size:10.5px;font-weight:700;'
      +'padding:2px 8px;border-radius:20px;background:'+est.bg+';color:'+est.fg+'">'
      +murEsc(est.t)+'</div>';
    var det=murDetalle(l);
    h+='<div style="display:flex;justify-content:space-between;align-items:flex-end;'
      +'margin-top:8px;gap:8px">'
      +'<span style="min-width:0">'
        +'<span style="font-size:12px;color:var(--text2);display:block">'+murBultos(l)+'</span>'
        +(det?('<span style="font-size:11px;color:var(--text3);display:block;margin-top:1px">'
               +det+'</span>'):'')
      +'</span>'
      +'<span style="font-size:14px;font-weight:700;white-space:nowrap">'+murMon(sub)+'</span></div>';
    h+='</div></div>';
  });
  h+='</div>';

  // ── Resumen de lo que no puede salir ──
  var pend=MUR_LINEAS.filter(function(l){
    var e=murEstado(l); return e.k==='camino'||e.k==='falta';
  });
  if(pend.length){
    h+='<div style="margin:0 16px 20px;padding:12px 14px;border-radius:10px;'
      +'background:var(--surface,#fff);border:1px solid var(--border,#e5e7eb);'
      +'border-left:4px solid #EF9F27;font-size:12.5px;color:var(--text2)">'
      +'<b>'+pend.length+' de '+MUR_LINEAS.length+'</b> referencia(s) no salen completas hoy. '
      +'La etiqueta de cada foto dice cu\u00e1ndo llega.</div>';
  }

  h+='<div style="height:20px"></div>';
  ov.innerHTML=h;
}

function murCerrar(){
  var o=document.getElementById('mur-overlay');
  if(o) o.remove();
  document.body.style.overflow='';
}


/* ══════════════════════════════════════════════════════════════════════════
   PDF
   ══════════════════════════════════════════════════════════════════════════ */

// Descarga la foto y la deja en JPEG. Se recomprime SIEMPRE lo que no sea
// JPEG: jsPDF incrusta los PNG como RGB sin comprimir y un mural de 20 fotos
// se iria a decenas de megas, que por WhatsApp no pasa.
async function murImg(url){
  var blob=await (await fetch(url,{mode:'cors'})).blob();
  var dataUrl=await new Promise(function(res,rej){
    var fr=new FileReader();
    fr.onload=function(){ res(fr.result); };
    fr.onerror=function(){ rej(new Error('no se pudo leer')); };
    fr.readAsDataURL(blob);
  });
  var dim=await new Promise(function(res,rej){
    var im=new Image();
    im.onload=function(){ res({w:im.naturalWidth||im.width, h:im.naturalHeight||im.height}); };
    im.onerror=function(){ rej(new Error('no se pudo decodificar')); };
    im.src=dataUrl;
  });
  var esJpeg=/jpe?g/i.test(blob.type||'');
  var LADO=700;
  if(esJpeg && Math.max(dim.w,dim.h)<=LADO && (blob.size||0)<=300*1024){
    return {data:dataUrl, ext:'JPEG', w:dim.w, h:dim.h};
  }
  var esc=Math.min(1, LADO/Math.max(dim.w,dim.h));
  var cw=Math.round(dim.w*esc), ch=Math.round(dim.h*esc);
  var cv=document.createElement('canvas'); cv.width=cw; cv.height=ch;
  var cx=cv.getContext('2d');
  cx.fillStyle='#fff'; cx.fillRect(0,0,cw,ch);
  var im2=new Image();
  await new Promise(function(res,rej){ im2.onload=res; im2.onerror=rej; im2.src=dataUrl; });
  cx.drawImage(im2,0,0,cw,ch);
  return {data:cv.toDataURL('image/jpeg',0.8), ext:'JPEG', w:cw, h:ch};
}

// Devuelve el Blob, para poder compartirlo ademas de descargarlo.
async function murPdfBlob(aviso){
  if(typeof catCargarLib==='function') await catCargarLib();
  if(!(window.jspdf && window.jspdf.jsPDF)) throw new Error('No se pudo cargar el generador de PDF');
  var jsPDF=window.jspdf.jsPDF;
  var doc=new jsPDF({unit:'pt', format:'letter'});
  var W=doc.internal.pageSize.getWidth(), H=doc.internal.pageSize.getHeight();
  var M=32, y=M;

  var tot=0;
  MUR_LINEAS.forEach(function(l){
    tot+=murNum(l.linetotal!=null?l.linetotal:(murNum(l.quantity)*murNum(l.price)));
  });

  doc.setFont('helvetica','bold'); doc.setFontSize(15); doc.setTextColor(15,15,15);
  doc.text('KENNEDY CENTER CORP.', M, y+4);
  doc.setFont('helvetica','normal'); doc.setFontSize(10); doc.setTextColor(90,90,90);
  y+=20;
  doc.text('Pedido '+(MUR_HEAD.docnum||MUR_DOC)+'  \u00b7  '+(MUR_HEAD.cardname||''), M, y);
  y+=13;
  doc.text((MUR_HEAD.nombrevendedor||'')+(MUR_HEAD.docdate?('  \u00b7  '+murFecha(MUR_HEAD.docdate)):''), M, y);
  doc.setFont('helvetica','bold'); doc.setFontSize(14); doc.setTextColor(15,15,15);
  doc.text(murMon(tot), W-M, y, {align:'right'});
  y+=14;
  doc.setDrawColor(200,200,200); doc.line(M, y, W-M, y);
  y+=12;

  // Tres tarjetas por fila, como en pantalla.
  var cols=3, gap=12;
  var cw=(W-2*M-gap*(cols-1))/cols, ih=cw*0.72, ch=ih+72;
  var col=0;

  for(var i=0;i<MUR_LINEAS.length;i++){
    var l=MUR_LINEAS[i], sku=String(l.itemcode||'');
    var inv=MUR_INV[sku]||{}, est=murEstado(l);
    var sub=murNum(l.linetotal!=null?l.linetotal:(murNum(l.quantity)*murNum(l.price)));

    if(col===0 && y+ch > H-M){ doc.addPage(); y=M; }
    var x=M+col*(cw+gap);

    doc.setDrawColor(225,225,225); doc.setLineWidth(.6);
    doc.roundedRect(x, y, cw, ch, 6, 6);

    var puesta=false;
    var par=null;
    try{ if(typeof fotoPair==='function') par=fotoPair(inv.pn, inv.fu); }catch(e){}
    if(par && par.primary){
      if(aviso) aviso(i+1, MUR_LINEAS.length);
      var cands=[par.primary].concat(String(par.fb||'').split('|')).filter(Boolean);
      for(var c=0;c<cands.length && !puesta;c++){
        try{
          var im=await murImg(cands[c]);
          var esc=Math.min((cw-2)/im.w, (ih-2)/im.h);
          doc.addImage(im.data, im.ext, x+1+((cw-2)-im.w*esc)/2, y+1+((ih-2)-im.h*esc)/2,
                       im.w*esc, im.h*esc);
          puesta=true;
        }catch(e){}
      }
    }
    if(!puesta){
      var cc=murColor(sku);
      doc.setFillColor(cc[0]); doc.rect(x+1, y+1, cw-2, ih-2, 'F');
      doc.setFont('helvetica','bold'); doc.setFontSize(8); doc.setTextColor(cc[1]);
      doc.text(doc.splitTextToSize(l.dscription||sku, cw-16).slice(0,3), x+8, y+ih/2-6);
    }

    var ty=y+ih+13;
    if(puesta){
      doc.setFont('helvetica','bold'); doc.setFontSize(8.5); doc.setTextColor(25,25,25);
      doc.text(doc.splitTextToSize(l.dscription||sku, cw-12).slice(0,2), x+6, ty);
      ty+=(String(l.dscription||sku).length>34?18:9);
    }
    doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(130,130,130);
    doc.text(sku, x+6, ty);
    ty+=11;
    doc.setFontSize(7.5); doc.setTextColor(est.fg);
    doc.text(est.t, x+6, ty);
    ty+=12;
    doc.setFontSize(8); doc.setTextColor(90,90,90);
    doc.text(murBultos(l), x+6, ty);
    doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(20,20,20);
    doc.text(murMon(sub), x+cw-6, ty, {align:'right'});
    var det=murDetalle(l);
    if(det){
      ty+=9;
      doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(140,140,140);
      doc.text(det, x+6, ty);
    }

    col++;
    if(col>=cols){ col=0; y+=ch+gap; }
  }
  if(col>0) y+=ch+gap;

  if(y+40 > H-M){ doc.addPage(); y=M; }
  doc.setDrawColor(200,200,200); doc.line(M, y, W-M, y);
  doc.setFont('helvetica','bold'); doc.setFontSize(13); doc.setTextColor(15,15,15);
  doc.text('TOTAL:  '+murMon(tot), W-M, y+20, {align:'right'});

  return doc.output('blob');
}

async function murPdf(){
  var b=document.getElementById('mur-btn-pdf');
  var prev=b?b.innerHTML:null;
  if(b){ b.disabled=true; b.textContent='Generando\u2026'; }
  try{
    var blob=await murPdfBlob(function(d,t){ if(b) b.textContent='Fotos '+d+'/'+t+'\u2026'; });
    var a=document.createElement('a');
    a.href=URL.createObjectURL(blob);
    a.download='pedido-'+(MUR_HEAD.docnum||MUR_DOC)+'.pdf';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function(){ URL.revokeObjectURL(a.href); }, 4000);
  }catch(e){
    alert('No se pudo generar el PDF: '+(e&&e.message?e.message:e));
  }finally{
    if(b){ b.disabled=false; b.innerHTML=prev; }
  }
}


/* ══════════════════════════════════════════════════════════════════════════
   ENVIAR
   ---------------------------------------------------------------------------
   En el iPad y el iPhone se usa el menu nativo de compartir, que deja mandar
   el PDF directo a WhatsApp con el archivo adjunto. wa.me NO permite adjuntar
   archivos, solo texto, asi que en escritorio se descarga el PDF y se abre
   WhatsApp con el resumen escrito para que el vendedor lo arrastre.
   ══════════════════════════════════════════════════════════════════════════ */

function murResumen(){
  var tot=0;
  MUR_LINEAS.forEach(function(l){
    tot+=murNum(l.linetotal!=null?l.linetotal:(murNum(l.quantity)*murNum(l.price)));
  });
  var pend=MUR_LINEAS.filter(function(l){ return murEstado(l).k==='camino'; });
  var t='Pedido '+(MUR_HEAD.docnum||MUR_DOC)+' \u2014 '+(MUR_HEAD.cardname||'')+'\n'
    +MUR_LINEAS.length+' referencias \u00b7 '+murMon(tot)+'\n';
  if(pend.length) t+='\n'+pend.length+' referencia(s) vienen en camino, la fecha va en el PDF.\n';
  t+='\nKennedy Center Corp.';
  return t;
}

async function murEnviar(){
  var b=document.getElementById('mur-btn-env');
  var prev=b?b.innerHTML:null;
  if(b){ b.disabled=true; b.textContent='Preparando\u2026'; }
  try{
    var blob=await murPdfBlob(function(d,t){ if(b) b.textContent='Fotos '+d+'/'+t+'\u2026'; });
    var nombre='pedido-'+(MUR_HEAD.docnum||MUR_DOC)+'.pdf';
    var file=new File([blob], nombre, {type:'application/pdf'});

    if(navigator.canShare && navigator.canShare({files:[file]})){
      await navigator.share({files:[file], text:murResumen()});
    } else {
      var a=document.createElement('a');
      a.href=URL.createObjectURL(blob);
      a.download=nombre;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function(){ URL.revokeObjectURL(a.href); }, 4000);
      window.open('https://wa.me/?text='+encodeURIComponent(murResumen()), '_blank');
    }
  }catch(e){
    // Cancelar el menu de compartir lanza AbortError: no es un fallo.
    if(!e || e.name!=='AbortError'){
      alert('No se pudo preparar el env\u00edo: '+(e&&e.message?e.message:e));
    }
  }finally{
    if(b){ b.disabled=false; b.innerHTML=prev; }
  }
}
